(function() {
    'use strict';

    angular
        .module('app.cantidadesDestajo')
        .run(appRun);

    // appRun.$inject = ['routehelper'];

    /* @ngInject */
    function appRun(routehelper) {
        routehelper.configureRoutes(getRoutes());
    }

    function getRoutes() {
        return [
            {
                url: '/cantidades-destajo',
                config: {
                    templateUrl: 'app/cantidadesDestajo/cantidadesDestajo.html',
                    controller: 'CantidadesDestajo',
                    controllerAs: 'vm',
                    title: 'CantidadesDestajo'
                }
            },
            {
                url: '/editar-cantidad-destajo/:tipoPlanillaId/:planillaId/:id?',
                config: {
                    templateUrl: 'app/cantidadesDestajo/editarCantidadDestajo.html',
                    controller: 'EditarCantidadDestajo',
                    controllerAs: 'vm',
                    title: 'EditarCantidadDestajo'
                }
            }
        ];
    }
})();
